import React from "react";
import { useParams } from "react-router-dom";
import Careers from "../components/careerLibrary/Careers";
import CareerOpenWrapper from "../components/careerLibrary/CareerOpenWrapper";
import "../components/careerLibrary/careerLibrary.css";

function CareerLibrary() {
  const { sideTab, type, id } = useParams();

  if (sideTab !== "careers") {
    return null;
  }

  if (type === "open" || id) {
    return <CareerOpenWrapper />;
  }

  return <Careers />;
}

export default CareerLibrary;
